import { render, staticRenderFns } from "./InertReports.vue?vue&type=template&id=763d286a"
import script from "./InertReports.vue?vue&type=script&lang=js"
export * from "./InertReports.vue?vue&type=script&lang=js"
import style0 from "./InertReports.vue?vue&type=style&index=0&id=763d286a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports